import { render } from "./MdvForm.vue?vue&type=template&id=17438d57&scoped=true"
import script from "./MdvForm.vue?vue&type=script&lang=js"
export * from "./MdvForm.vue?vue&type=script&lang=js"

import "./MdvForm.vue?vue&type=style&index=0&id=17438d57&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17438d57"]])

export default __exports__